

export const homeIndex = {
  conventionId:1,
  newsList: [
    { id:1,newsTitle: '新闻标题1', newsSummary: '这是新闻内容的第一行。第一行。', createTime: '2025-10-21', link: '#' },
    { id:2,newsTitle: '新闻标题2', newsSummary: '这是新闻内容的第二行。这是新闻内容的第二行。', createTime: '2025-10-20', link: '#', isNew: true },
    { id:3,newsTitle: '新闻标题3', newsSummary: '这是新闻内容的第三行。这是新闻内容的第二行。这是新闻内容的第二行。', createTime: '2025-10-19', link: '#', isNew: false }

  ],
  specialColumns: [
    { title: '职教未来职业发展高校综合建设专栏', link: '#', color: '#4CAF50' },
    { title: '校联会年会专栏', link: '#', color: '#FF9800' },
    { title: '校联会2025年年会专栏', link: '#', color: '#FF9800' },
    // 更多专题栏目
  ],
  announcements: [
    { id:1,newsTitle: '2025年博鳌职业教育发展大会情况介绍', createTime: '2025-10-21', link: '#' },
    {id:2,newsTitle: '2025年博鳌职业教育发展大会情况介绍', createTime: '2025-10-21', link: '#' },
    { id:3,newsTitle: '2025年博鳌职业教育发展大会情况介绍', createTime: '2025-10-21', link: '#' },
    // 更多公告
  ],

  futureNews: [
    { title: '2025年博鳌职业教育发展大会情况介绍2025年博鳌职业教育发展大会情况介绍', link: '#' },
    { title: '2025年博鳌职业教育发展大会情况介绍', link: '#' },
    { title: '2025年博鳌职业教育发展大会情况介绍', link: '#' },
    { title: '2025年博鳌职业教育发展大会情况介绍', link: '#' },
    { title: '2025年博鳌职业教育发展大会情况介绍', link: '#' },
    { title: '2025年博鳌职业教育发展大会情况介绍', link: '#' },
  ],
  experts: [ ] ,
  results: [
   

  ],
  partners: [
     
  ]

}
export const newsInfoList = {
  list: [
     ],
  total: 3
}
export const newsDetail1 = {
  id: 1,
  title: '落实宏观增量政策，推进绿色低碳转型111',
  content: '2024年12月13日、博黎亚洲论标研究院与能源县金会在北京联合丰办"安现档品动告推动绿色转型”例门研讨会、会议围终推动实现能源转型与绿色发展、共同应对全球挑战等用大课题 结会刚刚结束的中共中央经济工作会议释放的重要信号，以及中国近期出台的宏观增量政策推动中国绿色低碳转型及国际合作的前景展开深入探讨。与会嘉宾对绿色生产力助力中国经济社会实现全面绿色转型和可持续发展充满信心。能源基金会首席执行官兼中国区总裁邹骥、博鳌亚洲论坛研究院副院长营莉代表张军秘书长分别致欢迎辞。中国环境与发展国际合作委员会首席顾问刘世锦、中国人民银行金融研突所所长工志杰、国际货币基金组织驻华首席代表史蒂文·巴奈特发表主旨演讲，论坛合作伙伴沙特基础工业公司大中华区业务发展总监丁宁、电力规划总院新能源院院长王霁雪等资深专家参与圆桌讨论。曹莉副院长与能源基金会低碳转型项目主任杜譞共同主持会议。',
  date: '2025-10-21',
  source: '博职业发展大会新闻中心',
  "prev": {
    "id": 0,
    "title": "上一篇标题",
    "exists": false
  },
  "next": {
    "id": 2,
    "title": "落实宏观增量政策，推进绿色低碳转型222",
    "exists": true
  }
}
export const newsDetail2 = {
  id: 2,
  title: '落实宏观增量政策，推进绿色低碳转型222',
  content: '2024年12月13日、博黎亚洲论标研究院与能源县金会在北京联合丰办"安现档品动告推动绿色转型”例门研讨会、会议围终推动实现能源转型与绿色发展、共同应对全球挑战等用大课题 结会刚刚结束的中共中央经济工作会议释放的重要信号，以及中国近期出台的宏观增量政策推动中国绿色低碳转型及国际合作的前景展开深入探讨。与会嘉宾对绿色生产力助力中国经济社会实现全面绿色转型和可持续发展充满信心。能源基金会首席执行官兼中国区总裁邹骥、博鳌亚洲论坛研究院副院长营莉代表张军秘书长分别致欢迎辞。中国环境与发展国际合作委员会首席顾问刘世锦、中国人民银行金融研突所所长工志杰、国际货币基金组织驻华首席代表史蒂文·巴奈特发表主旨演讲，论坛合作伙伴沙特基础工业公司大中华区业务发展总监丁宁、电力规划总院新能源院院长王霁雪等资深专家参与圆桌讨论。曹莉副院长与能源基金会低碳转型项目主任杜譞共同主持会议。',
  date: '2025-10-21',
  source: '博职业发展大会新闻中心',
  "prev": {
    "id": 1,
    "title": "落实宏观增量政策，推进绿色低碳转型111",
    "exists": true
  },
  "next": {
    "id": 3,
    "title": "落实宏观增量政策，推进绿色低碳转型3333",
    "exists": true
  }
}
export const newsDetail3 = {
  id: 3,
  title: '落实宏观增量政策，推进绿色低碳转型3333',
  content: '2024年12月13日、博黎亚洲论标研究院与能源县金会在北京联合丰办"安现档品动告推动绿色转型”例门研讨会、会议围终推动实现能源转型与绿色发展、共同应对全球挑战等用大课题 结会刚刚结束的中共中央经济工作会议释放的重要信号，以及中国近期出台的宏观增量政策推动中国绿色低碳转型及国际合作的前景展开深入探讨。与会嘉宾对绿色生产力助力中国经济社会实现全面绿色转型和可持续发展充满信心。能源基金会首席执行官兼中国区总裁邹骥、博鳌亚洲论坛研究院副院长营莉代表张军秘书长分别致欢迎辞。中国环境与发展国际合作委员会首席顾问刘世锦、中国人民银行金融研突所所长工志杰、国际货币基金组织驻华首席代表史蒂文·巴奈特发表主旨演讲，论坛合作伙伴沙特基础工业公司大中华区业务发展总监丁宁、电力规划总院新能源院院长王霁雪等资深专家参与圆桌讨论。曹莉副院长与能源基金会低碳转型项目主任杜譞共同主持会议。',
  date: '2025-10-21',
  source: '博职业发展大会新闻中心',
  "prev": {
    "id": 2,
    "title": "落实宏观增量政策，推进绿色低碳转型222",
    "exists": true
  },
  "next": {

    "exists": frameElement
  }
}



export const cases = [...Array(12)].map((_, i) => ({
  id: i + 1,
  title: `优秀案例 ${i + 1}`,
  province: ['北京市', '上海市', '广东省', '江苏省', '浙江省'][i % 5],
  date: `2023-0${i % 12 + 1}-${10 + i % 20}`,
  description: '这是一段关于本案例的简要说明文字，展示核心成果与创新点...',
  image: `https://picsum.photos/400/300?random=${i}`
}));
export const experts = [];
export const institutions = {
  total: 12,
  data: [...Array(12)].map((_, i) => ({
    id: i + 1,
    collegeName: '北京财贸职业学院',
    province: ['北京市', '上海市', '广东省', '江苏省', '浙江省'][i % 5],
    collegeImage: `https://picsum.photos/400/300?random=${i}`,
    collegeUrl:"https://www.baidu.com"
  }))
}
export const conferenceUnits={
  1:[
    { name: '中华职业教育社' },
    { name: '人社部国际合作司' },
    { name: '江苏省教育厅' },
    { name: '无锡市人民政府' }],
  2:[
    { name: '中华职业教育社' },
    { name: '人社部国际合作司' },
    { name: '江苏省教育厅' },
    { name: '无锡市人民政府' }],
  3:[
    { name: '中华职业教育社' },
    { name: '人社部国际合作司' },
    { name: '江苏省教育厅' },
    { name: '无锡市人民政府' }],
  4:[  { name: '江苏省教育厅' },
    { name: '江苏省商务厅' },
    { name: '江苏省中华职教社' },
    { name: '江苏省人力资源和社会保障厅' },
    { name: '江苏省贸促会' },
    { name: '江苏省国际交流协会' },
    { name: '江苏省外办' }],
  5: [{ name: '江苏省教育厅' },
    { name: '江苏省商务厅' },
    { name: '江苏省中华职教社' },
    { name: '江苏省人力资源和社会保障厅' },
    { name: '江苏省贸促会' },
    { name: '江苏省国际交流协会' },
    { name: '江苏省外办' },
    { name: '江苏省教育厅' },
    { name: '江苏省商务厅' },
    { name: '江苏省中华职教社' },
    { name: '江苏省人力资源和社会保障厅' },
    { name: '江苏省贸促会' },
    { name: '江苏省国际交流协会' },
    { name: '江苏省外办' }],
  6: [
      { name: '无锡市教育局' },
      { name: '无锡市贸促会' },
      { name: '无锡市人力资源和社会保障局' },
      { name: '无锡市外办' },
      { name: '无锡市经开区政府' }
    ]
  
}
 
export const eventsDetail = {
  id: 1
}
export const eventsOverview = {
 
    bannerImage: '',
    conferenceTitle: '2023全球数字创新大会',
    conferenceDate: '2023年11月15-17日',
    conferenceLocation: '中国·上海国际会议中心',
    conferenceIntro: '本届大会以“数字赋能·智创未来”为主题，汇聚全球顶尖专家学者、行业领袖...',
    highlightCards: [
      {
        icon: 'icon-speaker',
        title: '重量级嘉宾',
        content: '500+位行业领袖与专家学者'
      },
      {
        icon: 'icon-enterprise',
        title: '参与企业',
        content: '200+家世界500强企业'
      },
      {
        icon: 'icon-topic',
        title: '前沿议题',
        content: '30+个数字科技核心议题'
      }
    ]


}

export const eventCases=[
  {
    title: '一、案例征集对象',
    contents: [
      '全国各职业院校、职业培训机构及国内公司等。'
    ]
  },
  {
    title: '二、案例征集内容',
    contents: [
      '案例应突出职业教育对外交流与合作办学特色，且成效显著，效益突出，具有示范性和推广价值。具体内容包括:总结国际交流与合作办学的途径和改革成果，完善中外合作机制，积极引进国(境)外高水平专家和优质教学资源;推动与中国企业和产品“走出去”相配套的职业教育发展模式，注重培养符合中国企业海外生产经营需求的本土化人才;开发与国际先进标准对接的专业标准和课程体系;积极探索中外职业院校教师互派、学生互换，开展职业培训的办学途径;境外驻华机构及跨国公司在华国际合作和项目成果的情况等。'
    ]
  },
  {
    title: '三、案例征集要求',
    contents: [
      '案例的内容要包括特色和亮点，具体撰写时，可先介绍学校对外交流合作的办学情况，最后写案例的背景、指导思想、具体做法和措施。'
    ]
  },
  {
    title: '四、成果推广',
    contents: [
      '案例将于2024年9月12日在江苏无锡举行的大会上发布优秀案例集。'
    ]
  },
  {
    title: '五、案例征集时间',
    contents: [
      '征集时间：2024年6月9日—2024年9月1日',
      '投稿邮箱：cscdaad@163.com'
    ]
  }
]

export const eventForums= [
  {
      id: 1,
      image: 'https://picsum.photos/400/300',
      title: '中亚(塔吉克斯坦)国家职业教育交流研讨会',
      summary: '为深入贯彻习近平总书记对职业教育工作的重要指示及全国职业教育大会精神，由无锡市人民政府、德国联邦经济事务和气候行动部(原德国经济与能源部)、德国驻华大使馆、德国联邦职业技术教育与培训研究所BIBB、德国巴伐利亚州教育与文化部、德国巴登符腾堡州教育、青年和体育部、德国联邦...'
  },
  
]